import * as types from './actionTypes';
import { getTagsDataUrl } from './../../Constants/Api';
import axios from 'axios';
import { openErrorSnackBar, openSuccessSnackBar } from './snackBarActions';
import { tagsApiErrorMsg } from '../../Constants/ErrorMessages';
import { logAndReturnErrorMsg } from '../../Utils/ErrorLog';
import { updateAssetsData } from './assetsAction';

export function dispatchActionData(type, data) {
	return { type: type, data: data };
}
//gets data from the requested url and returns a promise
export function getTags() {
	return axios
		.get(getTagsDataUrl)
		.then((response) => {
			return response.data;
		})
		.catch((error) => {
			throw error;
		});
}
// getting tags data from tags end point.
// adding search value as part of options to create new tags on fly.
// with a different type to be able to group by
export function loadTagsSearchData(data) {
	return function (dispatch) {
		return getTags(data)
			.then((response) => {
				response = response.map((tag) => {
					return tag.tag;
				});
				dispatch(dispatchActionData(types.LOAD_TAGS_SEARCH_DATA, response));
			})
			.catch((error) => {
				dispatch(openErrorSnackBar(logAndReturnErrorMsg(error, tagsApiErrorMsg)));
			})
			.finally(() => {});
	};
}
//adding selected tags
export function addSelectedTags(data) {
	return function (dispatch) {
		dispatch(dispatchActionData(types.ADD_TAG_SELECTED, data));
	};
}

//delete tags
export function deleteSelectedTag(data) {
	return function (dispatch) {
		dispatch(dispatchActionData(types.DELETE_TAG_SELECTED, data));
	};
}
//remove all tags
export function removeAllSelectedTags() {
	return function (dispatch) {
		dispatch(dispatchActionData(types.REMOVE_ALLTAGS_SELECTED));
	};
}

//reset tags data (options and selected tags)
export function resetTagsData() {
	return { type: types.RESET_TAGS_DATA };
}

//remove all tags for an asset
export function removeAllTagsFromAnAsset(asset) {
	return async function (dispatch) {
		try {
			//Removing all tags for this asset
			const updatedAssetObj = Object.assign({}, asset, {
				tags: [],
			});
			await dispatch(updateAssetsData(updatedAssetObj));
			dispatch(openSuccessSnackBar('All tags removed from ' + asset.name + ' asset '));
		} catch (error) {
			dispatch(openErrorSnackBar('Error removing tags from asset ' + asset.name + error.message));
		}
	};
}
